import { render, staticRenderFns } from "./EditWhItem.vue?vue&type=template&id=94c870fa&"
import script from "./EditWhItem.vue?vue&type=script&lang=js&"
export * from "./EditWhItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports